var map = {
	"./ajeyaraj.jpg": 6958,
	"./atharva.jpg": 2242,
	"./ayushi.jpg": 754,
	"./ayushi2.jpg": 50,
	"./devanshi.jpg": 7171,
	"./dewyani.jpg": 6728,
	"./gauri.jpg": 1271,
	"./jaivik.jpg": 9507,
	"./kevin.jpg": 1222,
	"./kevind.jpg": 8536,
	"./malay.jpg": 8849,
	"./navneet.jpg": 3882,
	"./pratamesh.jpg": 6120,
	"./prof_kulkarni.jpg": 3100,
	"./prof_talele.jpg": 6952,
	"./samarth.jpg": 1773,
	"./shubh.jpg": 9545,
	"./siddhant.jpg": 8254,
	"./sridhar.jpg": 9044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4882;